// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"background__Backdrop__1hRKQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/background.css
// module id = 103
// module chunks = 0